import React from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
const StyledIcon = styled(Icon)(
  ({ theme, $isFavorite }) => css`
    color: ${$isFavorite ? theme.colors.variant.info : void 0};
    cursor: pointer;
  `
);
const CommonFavoriteIcon = ({ className = void 0, onClick, title, isFavorite }) => /* @__PURE__ */ React.createElement(
  StyledIcon,
  {
    className,
    onClick,
    title,
    $isFavorite: isFavorite,
    name: "star",
    type: isFavorite ? "solid" : "regular"
  }
);
export default CommonFavoriteIcon;
